import { Component, Input } from '@angular/core';
import { CourseEqualizationStatus } from '../../models/CourseEqualization';

@Component({
    selector: 'app-course-equalization-status',
    template: `
<span class="badge" *ngIf="value"
        [class.text-bg-primary]="value == 'Project'"
        [class.text-bg-success]="value == 'Approved'"
        [class.text-bg-dark]="value == 'Submitted'"
        [class.text-bg-secondary]="value == 'Draft'"
        [class.text-bg-warning]="value == 'ReturnedForAddition' || value == 'ReturnedForApproval'"
        [class.text-bg-info]="value == 'Registered'">
    {{'courseEqualization_status' + value | translate}}
</span>
`
})
export class CourseEqualizationStatusComponent {
    @Input() value: CourseEqualizationStatus;
}
